import $ from 'jquery'
import ChartHierarchicalSelectorsSectionStrategy from './ChartHierarchicalSelectorsSectionStrategy'
import {Errors} from './constants'

function TaskHierarchicalSelectorsSectionStrategy({showUserSelector, showIncludeOtherUsersCheckbox, taskUserSelector}) {
    this.params = {
        showUserSelector,
        showIncludeOtherUsersCheckbox,
        taskUserSelector,
    }
}

TaskHierarchicalSelectorsSectionStrategy.prototype = new ChartHierarchicalSelectorsSectionStrategy()

TaskHierarchicalSelectorsSectionStrategy.prototype.updateSectionUI = function() {
    ChartHierarchicalSelectorsSectionStrategy.prototype.updateSectionUI.call(this)
    let classes = this.getVisibleCPSelectorClassName() + " " + this.getVisibleUserSelectorInfoIconClassName()
    classes += this.params.showUserSelector ? " " + this.getVisibleTaskUsersSelectorClassName() : " " + this.getVisibleUsernameClassName()
    classes += this.params.showIncludeOtherUsersCheckbox ? " " + this.getVisibleIncludeOtherUsersCheckboxClassName() : ""

    $(this.container).addClass(classes)
}

TaskHierarchicalSelectorsSectionStrategy.prototype.withUserSelector = function() {
    return this.params.showUserSelector
}

TaskHierarchicalSelectorsSectionStrategy.prototype.getUserSelection = function() {
    return this.params.taskUserSelector.getSelection()
}

TaskHierarchicalSelectorsSectionStrategy.prototype.getSelectedParams = function() {
    return {
        userSelection: this.params.taskUserSelector.getSelection(),
        customersProjectsSelection: this.cpSelector.getCpSelection(),
        includeOtherUsersColumn: this.includeOtherUsersCheckbox.isChecked()
    }
}

TaskHierarchicalSelectorsSectionStrategy.prototype.validate = function() {
    let errors = []

    if (!this.cpSelector.checkSelected())
        errors.push(Errors.ERROR_EMPTY_CP_SELECTION)
    if (!this.validateIsUserSelected())
        errors.push(Errors.ERROR_EMPTY_TASK_USER_SELECTION)

    return errors
}

TaskHierarchicalSelectorsSectionStrategy.prototype.validateIsUserSelected = function() {
    return this.params.taskUserSelector.validateIsUserSelected()
}

TaskHierarchicalSelectorsSectionStrategy.prototype.isShowIncludeOtherUsersCheckbox = function() {
    return this.params.showIncludeOtherUsersCheckbox
}

TaskHierarchicalSelectorsSectionStrategy.prototype.setUserSelection = function(selection) {
    this.params.taskUserSelector.setSelection(selection)
}

export default TaskHierarchicalSelectorsSectionStrategy


// WEBPACK FOOTER //
// ./web/js/reports/charts/TaskHierarchicalSelectorsSectionStrategy.js